<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <p class="add-title">历史诊断</p>
        <div class="model-cont">
          <button class="btn btn-hide"  @click="closeSub">关闭</button>

          <div v-if="next_id>0">
            <div class="history-list">
              <div class="history-num">
                <p v-for="(item,index) in addObj.history" :key="index" :class="historyID == item.id ? 'select' : ''" @click="lookDetail(item)">第{{item.key}}次诊断</p>
              </div>
              <div class="history-txt">
                <p>考试时间：{{addObj.exam.exam_time}}</p>
                <p>诊断时间：{{addObj.exam.add_time}}</p>
                <p>考试成绩：{{addObj.exam.score}}分</p>
                <button class="btn btn-export" @click="exportResult">导出完整报告</button>
              </div>
            </div>

            <div class="step-list">
              <div class="step-item" :class="next_id==item.id?'select':''" v-for="(item,index) in steptTitle" :key="item.id" @click="stepSub(item)">
                <p>{{(index+1)}}</p>
                <span>{{item.title}}</span>
                <i class="line" v-if="index<3"></i>
              </div>
            </div>
          </div>
        </div>
        
        <div class="step-cont result-cont" v-if="next_id==0">
          <div class="model-item">
            <div class="user-info clear">
              <div class="user-name">
                <p>学员: {{addObj.name}}</p>
                <p>{{addObj.sex==1?'男':'女'}}</p>
                <p>{{addObj.grade}}</p>
                <p>{{addObj.school}}</p>
              </div>
              <button class="btn btn-look" @click="lookDetail('first')">查看历史诊断</button>
            </div>

            <div class="write-txt">
              <div class="topic-data">
                <p class="add-title">总分统计</p>
                <div class="chartBox" id="totalBox"></div>
                <div class="total-cont">
                  <div class="total-item" v-for="(item,index) in addObj.exam_statistics" :key="index">
                    <p>第{{(index+1)}}次诊断</p>
                    <p>{{item.score}}分</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="write-txt">
              <div class="topic-data">
                <p class="add-title">各板块统计</p>
                <div class="block-item" v-for="(item,index) in addObj.sector_statistics" :key="index">
                  <p class="block-title">板块{{(item.que_num)}}</p>
                  <div class="chartBox" :id="'sector'+'_'+item.que_num"></div>
                  <div class="exam-cont">
                    <div class="exam-item" v-for="(ele,num) in item.statistics" :key="num">
                      <p>第{{(num+1)}}次诊断</p>
                      <p>扣分率: {{ele.deduct_rate}}%</p>
                      <p>提分值: {{ele.increase}}</p>
                      <p>提分率: {{ele.increase_rate}}%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step-cont paper-cont" v-if="next_id==1">
          <div class="model-item">
            <p class="info-title">基本信息</p>
            <p class="paper-title">试卷：{{addObj.exam_title}}</p>
            <div class="write-txt">
              <div class="paper-item" v-for="(item,index) in errorList" :key="index">
                <p>错题题号:{{item.que_num}}</p>
                <p>错题扣分:{{item.deduct}}分</p>
              </div>
            </div>
          </div>

          <div class="model-item clear">
            <p class="info-title">各个考点扣分情况</p>
            <div class="table-cont">
              <div class="table-title">
                <p v-for="(item,index) in tableTitle" :key="index">{{item.title}}</p>
              </div>
              <div class="table-list">
                <div class="table-item" v-for="(item,index) in addObj.exam_sites" :key="index">
                  <p>{{item.exam_site}}</p>
                  <p>{{item.topic_score}}</p>
                  <p>{{item.deduct}}</p>
                  <p>{{item.deduct_rate}}%</p>
                </div>
              </div>
            </div>
          </div>


          <div class="model-cont">
            <div class="model-item">
              <p class="info-title">错题统计</p>
              <div class="write-txt" v-for="(item,index) in sectorData" :key="index">
                <p class="add-title">板块{{(index+1)}}: {{item.title}} <span>扣{{item.deduct}}分</span></p>
                <div v-for="(ele,num) in item.material" :key="num">
                  <div class="" v-for="(i,k) in ele.topic" :key="k">
                    <div class="topic-data">
                      <p class="write-title"><span>*</span>第{{k+1}}题:{{i.topic_title}}</p>
                      <div class="exam-txt">
                        <p v-for="(n,m) in i.exam_sites" :key="m">考点：{{n}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step-cont wrong-cont" v-if="next_id==2">
          <div class="write-txt" v-for="(item,index) in addObj.ea" :key="index">
            <div class="topic-data">
              <p class="add-title">错题{{(index+1)}}</p>
              <div class="write-title"><span>*</span>1{{item.topic_title}}</div>
            </div>
            <div class="wrong-cause">
              <div class="wrong-btn">
                <div class="clear">
                  <p class="wrong-title">AI错因分析</p>
                  <button class="btn btn-wrong" @click="getAnalysis(item)">{{item.analysis?'重新分析':'开始分析'}}</button>
                </div>
                <div class="wrong-txt">
                  {{item.analysis?item.analysis:'暂无'}}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="step-cont score-cont noPointer" v-if="next_id==3">
          <div class="model-item">
            <div class="write-txt">
              <p class="write-title"><span>*</span>选择考试类型：</p>
              <div class="write-text">
                <el-select placeholder="请选择" v-model="addObj.exam_type">
                  <el-option
                    v-for="item in examTypeList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="write-txt write-ai">
              <p class="write-title">考试总目标：</p>
              <div class="write-text">
                <input type="text" v-model="addObj.exam_target">
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title"><span>*</span>总目标提分期限：</p>
              <div class="write-text">
                <el-date-picker
                  v-model="addObj.target_deadline"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  placeholder="选择日期">
                </el-date-picker>
                <!-- <p class="write-msg">仅能设置明天及以后的时间</p> -->
              </div>
            </div>
          </div>


          <div class="model-item" style="margin-top: 70px;">
            <div class="tager-list" v-for="(item,index) in addObj.models" :key="index">
              <div class="write-txt">
                <p class="write-title"><span>*</span>选择板块：</p>
                <div class="write-text">
                  <el-select placeholder="请选择" v-model="item.title" @change="examChange(item)">
                    <el-option
                      v-for="item in examDataList"
                      :key="item.id"
                      :label="item.title"
                      :value="item.title">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="write-txt write-score">
                <p class="write-title">目标分值：</p>
                <div class="write-text">
                  提高<input type="text" v-model="item.model_target">分
                </div>
              </div>
            </div>
            <button class="btn btn-score" @click="examAdd">+添加板块</button>
          </div>
        </div>

        <div class="step-cont plan-cont noPointer" v-if="next_id==4">
          <div class="model-item">
            <p class="info-title">总提分目标: <span>+{{totalNum}}分</span></p>
            <div class="modelsList">
              <p class="info-title">各板块提分目标: </p>
              <div style="display: block;padding-left: 100px;text-align: left;">
                <div v-for="(item,index) in addObj.models" :key="index">{{item.title}}：+{{item.model_target}}</div>
              </div>
              <!-- <div v-for="(item,index) in addObj.models" :key="index">{{item.title}}：+{{item.model_target}}</div> -->
            </div>
            <div class="write-txt" v-for="(item,index) in addObj.models" :key="index">
              <div class="topic-data">
                <p class="add-title">板块{{(index+1)}}: {{item.title}}<span>目标:{{item.model_target}}分</span></p>
              </div>
              <div class="wrong-cause">
                <div class="wrong-btn">
                  <div class="clear">
                    <p class="wrong-title">提分计划</p>
                  </div>
                  <div class="wrong-txt">
                    <textarea v-model="item.model_plan"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">确定</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="searchBox clear">
            <div class="search-item">
              <p>学员姓名:</p>
              <input type="text" placeholder="请输入要搜索的学员姓名" v-model="obj.name">
            </div>
            <div class="search-item">
              <p>手机号:</p>
              <input type="text" placeholder="请输入要搜索的手机号" v-model="obj.mobile">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="list-title">诊断列表</div>
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.sex==1?'男':'女'">{{item.sex==1?'男':'女'}}</p>
              <p :title="item.province + '/' + item.city">{{item.province}} / {{item.city}}</p>
              <p :title="item.school">{{item.school}}</p>
              <p :title="item.grade">{{item.grade}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p>
                <button title="历史诊断" class="btn btn-revise" @click="buildShow(item)">历史诊断</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHistoryExamSitList ,getHistoryExamSitReport ,saveTopic ,getHistoryExamSitStatistics ,delTopic,getExamSitReport} from "@/assets/js/api";
import * as echarts from 'echarts';
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "index",
  data() {
    return {
      navId:'9',
      childrenID:'9-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'姓名'},
        {id:3,title:'性别'},
        {id:4,title:'地区'},
        {id:5,title:'学校'},
        {id:6,title:'年级'},
        {id:7,title:'手机号'},
        {id:10,title:'操作'},
      ],
      dataList:[],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{},
      examDataList:[],
      totalPage:0,
      removeID:'',
      url:'',
      next_id:0,
      steptTitle:[
        {id:1,title:'弱点扫描'},
        {id:2,title:'错因分析'},
        {id:3,title:'制定目标'},
        {id:4,title:'训练计划'},
      ],
      tableTitle:[
        {id:1,title:'考点'},
        {id:2,title:'考点满分'},
        {id:3,title:'扣分'},
        {id:4,title:'扣分率'},
      ],
      sectorData:[],
      totalNum:0,
      errorList:[],
      examTypeList:[
        {id:1,title:'月考'},
        {id:2,title:'期中考'},
        {id:3,title:'期末考'},
        {id:4,title:'1模考'},
        {id:5,title:'2模考'},
        {id:6,title:'3模考'},
        {id:7,title:'中考'},
      ],
      pickerOptions: {
        disabledDate(time) {
          // 获取当前时间的毫秒数
          const now = Date.now();
          // 获取传入日期的毫秒数
          const date = time.getTime();
          // 如果传入日期的毫秒数小于当前时间的毫秒数，则返回true，表示禁用该日期
          return date < now;
        }
      },
      resultID:'',
      historyID:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize);
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.url = this.$refs.navBox.url;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getHistoryExamSitList(this.obj,this.token);
        if(response.code == 200){
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async addSub(){
      var that = this;
      this.addType = 'add';
    },

    async getAnalysis(e){
      var that = this;
      var obj = {
        content:e.content,
        topic:e.topic_title,
        answer:e.answer,
        my_answer:e.my_answer
      }
      try {
        const response = await addAiAnalysis(obj,this.token);
        if(response.code == 200){
          e.analysis = response.data.answer;
          that.$forceUpdate();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    examChange(e){
      var that = this;
      this.examDataList.forEach(function(item,index){
        if(item.title == e.title){
          e.id = item.id;
          e.que_num = item.que_num
        }
      })
    },

    examAdd(){
      this.addObj.models.push({id:'',que_num:'',title:'',model_target:'',model_plan:''})
    },

    async buildShow(e){
      var that = this;
      try {
        const response = await getHistoryExamSitStatistics({uid:e.uid},this.token);
        if(response.code == 200){
          that.addType = 'look';
          that.next_id = 0;
          // that.addObj = response.data;
          that.addObj.exam_statistics = response.data.exam_statistics;
          that.addObj.sector_statistics = response.data.sector_statistics;  
          that.addObj.name = e.name;
          that.addObj.sex = e.sex;
          that.addObj.grade = e.grade;
          that.addObj.school = e.school;
          that.addObj.uid = e.uid;
          var list1 = [];
          var list2 = [];
          response.data.exam_statistics.forEach(function(item,index){
            list1.push('第'+(index+1)+'次诊断');
            list2.push(item.score);
          })
          setTimeout(function(){
            that.initChart(list1,list2,'totalBox','line');
          },1000)
          response.data.sector_statistics.forEach(function(item,index){
            var list3 = [];
            var list4 = [];
            item.statistics.forEach(function(ele,num){
              list3.push('第'+(num+1)+'次诊断');
              list4.push(ele.deduct);
              setTimeout(function(){
                that.initChart(list3,list4,'sector'+'_'+item.que_num,'bar');
              },1000)
            })
          })
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    async lookDetail(e){
      var that = this;
      var obj = {
        uid : that.addObj.uid
      };
      if(e != 'first'){
        obj.id = e.id;
        that.historyID = e.id;
      }
      try {
        const response = await getHistoryExamSitReport(obj,this.token);
        if(response.code == 200){
          // console.log(response.data.report.exam.exam_title)
          // that.examList.forEach(function(item,index){
          //   if(item.title == response.data.report.exam.exam_title){
          //     that.addObj.eid = item.id;
          //   }
          // });
          that.addObj.exam = response.data.report.exam;
          that.addObj.exam_title = response.data.report.exam.exam_title;
          that.addObj.exam_time = response.data.report.exam.exam_time;
          that.addObj.score = response.data.report.exam.score;
          that.addObj.exam_sites = response.data.report.fs.exam_sites;
          that.sectorData = response.data.report.fs.sector;
          that.addObj.ea = response.data.report.ea;
          that.addObj.exam_type = response.data.report.sg.exam_type;
          that.addObj.exam_target = response.data.report.sg.exam_target;
          that.addObj.target_deadline = response.data.report.sg.target_deadline;
          that.addObj.models = response.data.report.sg.models;
          that.addObj.history = response.data.history;
          if(e=='first'){
            that.historyID = that.addObj.history[0].id;
          } 
          that.totalNum = response.data.report.tp.increase_score;
          that.errorList = response.data.report.fs.error;
          that.resultID = response.data.id;
          that.next_id =1;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    removeShow(e){
      this.removeID = e.tmid;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delTopic({tmid:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.province == ''){
        that.$message('请选择省！');
        return false;
      }
      if(this.addObj.city == ''){
        that.$message('请选择市！');
        return false;
      }
      if(this.addObj.period == ''){
        that.$message('请选择学段！');
        return false;
      }
      if(this.addObj.content == ''){
        that.$message('请填写文章内容！');
        return false;
      }
      if(this.addObj.explain == ''){
        that.$message('请填写解题步骤！');
        return false;
      }
      if(this.addObj.material_label_one == '' || this.addObj.material_label_one == '生成中...'){
        that.$message('请选择文章一级标签！');
        return false;
      }
      try {
          that.addObj.topic.forEach(function(item,index){
            if(item.topic == ''){
                that.$message('题目'+(index+1)+'题干还未填写');
                throw new Error("EndIterative");
            } 
            if(item.answer == ''){
                that.$message('题目'+(index+1)+'答案还未填写');
                throw new Error("EndIterative");
            } 
            if(item.topic_label_one == '' || item.topic_label_one == '生成中...'){
                that.$message('题目'+(index+1)+'题干一级标签还未填写');
                throw new Error("EndIterative");
            } 
          })
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      try {
        const response = await saveTopic(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {};
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
      };
      this.addObj={};
      this.totalPage = 0;
      this.dataList = [];
      this.getList();
    },

    initChart(list1,list2,title,type) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById(title));
      var formatter = '';
      if(type == 'bar'){
        formatter = '扣 {c} 分';
      } else {
        formatter = '{c} 分';
      }
      // 指定图表的配置项和数据
      const option = {
        tooltip: {
          show: true,
        },
        legend: {
          data:['正确率']
        },
        xAxis: {
            type: 'category',
            data: list1
        },
        yAxis: {
            type: 'value'
        },
        series: [{
          data: list2,
          type: type,
          label: {
              show: true ,// 显示数值
              position: 'top', 
              formatter: formatter 
          },
          itemStyle: {
            normal: {
                // 在这里你可以自定义柱子的颜色，例如使用color属性
                color: '#6098F2' // 红色
            }
          }
        }]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    chartResize() {
      this.$nextTick(() => {
        if (this.chart) {
          this.chart.resize();
        }
      });
    },

    stepSub(e){
      this.next_id = e.id
    },

    exportResult(){
      window.location.href = this.url  + 'intecl/Exam/exportExam?id='+this.resultID
    }
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 8 );
    white-space: nowrap; /* 禁止文本换行 */
    overflow: hidden; /* 隐藏超出范围的内容 */
    text-overflow: ellipsis; /* 使用省略号 */
    padding: 21px 5px;
  }

  /* .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 10px;
  } */

  .add-title,
  .list-title{
    color: #333333;
    font-size: 22px;
    display: block;
    margin-bottom: 20px;
    position: relative;
    padding-left: 20px;
    line-height: 40px;
  }

  .add-title::before,
  .list-title::before{
    content: '';
    width: 5px;
    height: 22px;
    background-color: #6098F2;
    position: absolute;
    top: 50%;
    transform: translate(0,-50%);
    left: 5px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 80%;
    height: 334px;
    background-color: #FFFFFF;
    border-radius: 6px;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    border: solid 1px #333333;
    font-size: 16px;
  }

  .MobelBox input{
    height: 50px;
    line-height: 50px;
    width: 500px;
  }

  .MobelBox>>> .el-input{
    font-size: 16px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.btn-ai{
  background-color: #6098F2;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;
  color: #fff;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 39px;
  line-height: 39px;
  display: inline-block;
  margin-left: 20px;
}

.ai-msg{
  height: 50px;
  line-height: 50px;
  color: #777777;
  font-size: 14px;
  display: inline-block;
  margin-left: 18px;
}

.MobelBox .write-ai .write-text{
  width: auto;
}


.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-add,
.topic-title .btn-remove{
  font-size: 18px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.topic-title .btn-remove{
  margin-left: 40px;
  background-color: transparent;
  color: #6098F2;
  border: solid 1px #6098F2;
}

.topic-title .btn-add{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 20px;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.btn-topic-add{
  font-size: 18px;
  color: #6098F2;
  margin: 30px 0 20px;
  display: block;  
  border: solid 1px #6098F2;
  border-radius: 6px;
  padding: 3px 30px;
  box-sizing: border-box;
}

.chartBox{
  display: block;
  width: 100%;
  height: 500px;
}

.model-cont{
  background-color: #fff;
  display: block;
  box-sizing: border-box;
  padding: 30px;
  border-radius: 6px;
  margin-bottom: 10px;
}

.MobelBox .model-cont .btn-hide{
  margin: 0 0 10px;
}

.model-cont .ai-msg{
  font-size: 12px;
  color: #999999;
}

.model-cont .msg-txt{
  background-color: #FFF0F0;
  border-radius: 6px;
  font-size: 12px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  padding: 11px 20px;
  box-sizing: border-box;
  margin-left: 10px;
}

.model-cont .icon-msg{
  background-image: url(~@/assets/images/icon-msg.png);
  width: 16px;
  height: 16px;
  background-size: 16px 16px;
  display: inline-block;
  vertical-align: middle;
}

.model-cont .add-title{
  font-size: 18px;
  font-weight: bold;
}

.step-cont{
  display: block;
}

.step-list{
  font-size: 0;
  display: block;
  text-align: center;
}

.step-list .step-item{
  display: inline-block;
  vertical-align: top;
  text-align: center;
  position: relative;
  margin-right: 150px;
}

.step-list .step-item.select p{
  border-color: #6098F2;
  background-color: #6098F2;
  color: #fff;
}

.step-list .step-item p{
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 100%;
  border: solid 2px #777777;
  font-size: 28px;
  color: #777777;
  display: block;
  margin: 0 auto .05rem;
}

.step-list .step-item.select span{
  color: #6098F2;
}

.step-list .step-item span{
  color: #777777;
  font-size: 18px;
  display: block;
  margin-top: 6px;
}

.step-list .step-item .line{
  width: 150px;
  height: 2px;
  background-color: #777777;
  position: absolute;
  top: 29px;
  right: -150px;
}

.info-title{
  font-size: 20px;
  color: #333333;
  display: block;
  margin: 20px 0;
  font-weight: bold;
}

.table-cont{
  display: block;
  width: 80%;
  float: right;
  text-align: center;
}

.table-list .table-item,
.table-cont .table-title{
  font-size: 0;
}

.table-list .table-item p,
.table-cont .table-title p{
  width: 25%;
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  padding: 20px 10px;
  box-sizing: border-box;
  background-color: #F0F4FB;
  display: inline-block;
  vertical-align: top;
}

.table-list .table-item p{
  background-color: #fff;
}

.wrong-cont .write-title,
.wrong-cont .add-title{
  display: inline-block;
  vertical-align: top;
}

.wrong-cont .write-title{
  line-height: 40px;
  margin-left: 24px;
}

.wrong-cause{
  font-size: 0;
}

.wrong-title{
  font-size: 18px;
  color: #333333;
  float: left;
  line-height: 40px;
}

.wrong-cause .btn-wrong{
  line-height: 40px;
  color: #6098F2;
  border-radius: 6px;
  border: solid 1px #6098F2;
  float: right;
  font-size: 16px;
  box-sizing: border-box;
  padding: 0 25px;
}

.wrong-cause .wrong-txt{
  background-color: #EDEDED;
  border-radius: 6px;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
}

.tager-list .write-score{
  margin-left: 50px;
}

.tager-list .write-score .write-text{
  font-size: 18px;
  color: #333333;
}

.tager-list .write-score .write-text input{
  display: inline-block;
  margin: 0 10px;
}

.score-cont .btn-score{
  font-size: 18px;
  color: #6098F2;
  box-sizing: border-box;
  padding: 6px 24px;
  border-radius: 6px;
  border: solid 1px #6098F2;
  display: block;
  margin-top: 30px;
}

.plan-cont .info-title span{
  font-size: 24px;
  color: #54EF07;
  margin-left: 25px;
}

.plan-cont .add-title span{
  font-size: 18px;
  color: #54EF07;
  margin-left: 35px;
}

.result-cont .user-info{
  font-size: 0;
  margin-bottom: 30px;
}

.result-cont .user-name{
  float: left;
}

.result-cont .user-name p{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  line-height: 40px;
  margin-right: 40px;
}


.result-cont .btn-look{
  float: right;
  color: #fff;
  background-color: #6098F2;
  border-radius: 6px;
  height: 40px;
  line-height: 40px;
  padding: 0 24px;
  font-size: 16px;
}

.result-cont .block-item{
  display: block;
}

.result-cont .block-title{
  display: block;
  font-size: 20px;
  color: #333333;
  margin: 20px 35px;
}

.history-list{
  margin: 30px 0 45px;
}

.history-num{
  font-size: 0;
  text-align: center;
  display: block;
  border-bottom: solid 1px #AAAAAA;
  margin-bottom: 30px;

   white-space: pre;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 10px;
}

.history-num::-webkit-scrollbar{
    height: 4px;
  }
  .history-num::-webkit-scrollbar-thumb{
    background-color: #ccc;
  }
.history-num p{
  display: inline-block;
  vertical-align: top;
  color: #333333;
  font-size: 24px;
  margin-right: 30px;
  padding-bottom: 14px;
}

.history-num p.select{
  color: #6098F2;
  border-bottom: solid 4px #6098F2;
}

.history-txt p{
  color: #333333;
  font-size: 20px;
  display: inline-block;
  vertical-align: top;
  margin-right: 30px;
}

.history-txt p:nth-of-type(3){
  color: #54EF07;
}

.history-txt .btn-export{
  background-color: #6098F2;
  border-radius: 6px;
  color: #6098F2;
  font-size: 16px;
  color: #fff;
  padding: 9px 24px;
  float: right;
}

.paper-title{
  font-size: 20px;
  color: #333333;
  margin: 10px 0 20px 80px;
  display: block;
}

.paper-cont .write-txt{
  font-size: 0;
  width: calc( 100% - 80px );
  margin-left: 80px;
}

.paper-cont .write-txt .paper-item{
  display: inline-block;
  vertical-align: top;
  width: calc( 100% / 5 - 30px );
  background-color: #F8F9FC;
  border-radius: 6px;
  margin:0 30px 20px 0;
  box-sizing: border-box;
  padding: 10px 16px;
}

.paper-cont .write-txt .paper-item p{
  display: block;
  font-size: 18px;
  color: #333333;
}

.paper-cont .write-txt .paper-item p:first-child{
  margin-bottom: 14px;
}

.paper-cont .add-title span{
  background-color: #F26060;
  color: #fff;
  padding: 3px 10px;
  box-sizing: border-box;
  margin-left: 20px;
  border-radius: 6px;
}

.paper-topic-item{
  margin-bottom: 20px;
}

.paper-topic-title p{
  font-size: 18px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
}

.paper-topic-title p:last-child{
  font-size: 14px;
  margin-left: 20px;
}

.paper-topic-exam{
  font-size: 14px;
  color: #6098F2;
  display: block;
  margin-top: 10px;
}

.modelsList{
  font-size: 0;
  text-align: center;
  margin: 20px 0 70px;
  display: block;
}

.modelsList p{
  text-align: left;
}

.modelsList div{
  font-size: 18px;
  color: #333333;
  margin-right: 30px;
  display: inline-block;
  vertical-align: top;
}

.exam-txt{
  font-size: 0;
  margin-top: 10px;
}

.exam-txt p{
  display: block;
  font-size: 14px;
  color: #6098F2;
  padding-bottom: 10px;
}

.exam-cont,
  .total-cont{
    font-size: 0;
    margin-bottom: 42px;
  }

  .exam-cont .exam-item,
  .total-cont .total-item{
    display: inline-block;
    vertical-align: top;
    background-color: #fff;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 10px 15px;
    margin: 0 15px 15px 0;
  }

  .total-cont .total-item p{
    display: block;
    color: #333333;
    font-size: 18px;
    margin-bottom: 6px;
  }

  .total-cont .total-item p:last-child{
    color: #6098F2;
    font-size: 14px;
    margin-top: 14px;
  }
  .exam-cont .exam-item p{
    color: #6098F2;
    font-size: 14px;
    display: block;
    margin-bottom: 6px;
  }

  .exam-cont .exam-item p:first-child{
    color: #333333;
    font-size: 18px;
    margin-bottom: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/study/history.vue